/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import moment from "moment";

export default {
  async fetchAllHistory({ commit }, param) {
    try {
      const response = await axios.get(
        "/user/students/history/" + param.studentId,
      );
      if (response.status === 200) {
        const res = response.data.data;
        const data = res.map((val) => {
          var title = val.log_name;
          var color;
          var icon;
          if (val.log_name.indexOf("course") > -1) {
            (color = "primary"), (icon = "PlusIcon"), (title = "Course");
          } else if (val.log_name.indexOf("freezing") > -1) {
            (color = "warning"), (icon = "MailIcon"), (title = "Freezing");
          } else if (val.log_name.indexOf("level") > -1) {
            (color = "danger"), (icon = "UsersIcon"), (title = "Level");
          }
          return {
            color: color,
            icon: icon,
            title: val.title,
            subtitle: title,
            desc: val.description,
            time: moment(val.created_at).fromNow(),
          };
        });
        commit("SET_LIST", data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  setPagination({ commit }, page) {
    commit("SET_PAGINATION", page);
  },
};
